module.exports = __webpack_public_path__ + "img/star-01.3b6a02e1.svg";